import Vue from "vue";
import ElementUI from "element-ui";
import us_en from "element-ui/lib/locale/lang/en";
import zh_cn from "element-ui/lib/locale/lang/zh-CN";
import gd from "element-ui/lib/locale/lang/zh-TW";
import { LOCALE } from "../js/local-name";

/** 多语言 picker columns */
export const languageColumns = [
    { text: "简", value: "zh_cn" },
    { text: " | ", value: "" },
    // { text: "繁体中文", value: "zh-HK" },
    { text: "ENG", value: "us_en" },
];
/** 当前语言 */
export const defaultProLang = () => {
    let lang = localStorage.getItem(LOCALE) || 'zh_cn';
    if (lang) {
        let language = lang == 'zh_cn' ? zh_cn : lang == 'zh_hk' ? gd : us_en
        Vue.use(ElementUI, { language })
        localStorage.setItem(LOCALE, lang);
    }
    // Locale.use(lang);
}
// // 设置语言
// locale.use(lang)
// Locale.use(locale);

export const getLang = () => localStorage.getItem(LOCALE) || "zh_cn";



// WEBPACK FOOTER //
// ./src/locale/utils.js